import { useEffect, useState } from "react";
import { coverFileProblem } from "../../cover.js";
import { themeOf, themeStyle } from "../../menuTheme.js";
import { PRO_TRIAL_DAYS } from "../../plans.js";
import { MenuHeader } from "../menu/MenuParts.jsx";
import { notifyError } from "./useBusiness";
import "../../menu.css";

// Foto de portada arriba del menú público (plan Pro). En Gratis invita a probar Pro.
const CoverPicker = ({ business, onSave, onRemove }) => {

    const pro = business.subscribed === true;
    const saved = business.portada || "";
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState("");
    const [busy, setBusy] = useState(false);

    useEffect(() => () => preview && URL.revokeObjectURL(preview), [preview]);

    const discard = () => {
        setFile(null);
        setPreview("");
    }

    const pick = (e) => {
        const chosen = e.target.files[0];
        e.target.value = "";
        if (!chosen) return;
        const problem = coverFileProblem(chosen);
        if (problem) {
            notifyError(problem);
            return;
        }
        setFile(chosen);
        setPreview(URL.createObjectURL(chosen));
    }

    const run = async (action) => {
        setBusy(true);
        const ok = await action();
        setBusy(false);
        if (ok) discard();
    }

    if (!pro) {
        return (
            <div className="lp-panel-stack">
                <p>Poné una foto grande arriba de tu menú: tu local, tu plato estrella o lo que mejor muestre tu negocio. Es lo primero que ven tus clientes al escanear el QR.</p>
                <p className="lp-panel-muted">La portada es del plan Pro. Mientras tanto, tu menú muestra una franja del color que elegiste.</p>
                <a className="lp-btn lp-btn-primary lp-panel-left" href="#cuenta">Probar Pro gratis {PRO_TRIAL_DAYS} días</a>
            </div>
        )
    }

    const shown = preview || saved;

  return (
    <div className="lp-panel-stack">
        <p className="lp-panel-muted">Usá una foto horizontal, por ejemplo de tu local o de tu plato estrella. En el celular se ve la parte del medio, así que dejá lo importante en el centro.</p>

        <div>
            <span className="lp-panel-label">{preview ? "Así va a quedar" : "Así lo ven tus clientes"}</span>
            <div className="lp-menu lp-menu-preview" style={themeStyle(themeOf(business))} aria-hidden="true">
                <div className="lp-menu-page">
                    <MenuHeader business={business} preview cover={shown}></MenuHeader>
                </div>
            </div>
        </div>

        <div className="lp-panel-actions">
            <label className="lp-btn lp-btn-secondary" htmlFor="cp-file">{shown ? "Elegir otra foto" : "Elegir foto"}</label>
            <input id="cp-file" className="lp-panel-file" type="file" accept="image/*" disabled={busy} onChange={pick}/>
            {file && <button type="button" className="lp-btn lp-btn-primary" disabled={busy} onClick={() => run(() => onSave(file))}>{busy ? "Guardando..." : "Guardar portada"}</button>}
            {file && <button type="button" className="lp-btn lp-btn-secondary" disabled={busy} onClick={discard}>Descartar</button>}
            {!file && saved && <button type="button" className="lp-text-link" disabled={busy} onClick={() => run(onRemove)}>{busy ? "Sacando..." : "Sacar portada"}</button>}
        </div>
    </div>
  )
}

export default CoverPicker
